import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { NgTemplateOutlet } from '@angular/common';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  TemplateRef,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import {
  AudioAction,
  AudioActionValue,
} from '../../../../../models/interactions.model';

@Component({
  selector: 'app-audio-action',
  imports: [MatIcon, MatIconButton, MatTooltip, CdkDragHandle, NgTemplateOutlet],
  templateUrl: './audio-action.component.html',
  styleUrl: './audio-action.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AudioActionComponent {
  public readonly data = input.required<AudioAction>();
  public readonly actions = input<TemplateRef<unknown>>();
  public readonly isPlaying = input(false, { transform: booleanAttribute });

  public readonly playChange = output<AudioActionValue>();
}
